import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_featured_brands: FaireCategoryEntity = {
  token: "cat_featured-brands",
  type: "category",
  name: "Featured brands",
  level: 1,
  href: "/category/featured-brands",
  childCategoryTokens: [
    "cat_featured-all",
    "cat_featured-new-products",
    "cat_featured-new-brands",
    "cat_featured-bestsellers",
    "cat_featured-specials",
    "cat_featured-fair-trade",
    "cat_featured-made-italy",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
